export const CLEAR_MODAL = 'CLEAR_MODAL'
export const OPEN_MODAL = 'OPEN_MODAL'
